/* eslint-disable no-console */
import { get } from 'lodash-es'

import { handleIdentify } from '../helpers/handleIdentify'
import { sa } from '../helpers/sa'
import { LoginTrackName, SignUpTrackName } from '../helpers/trackName'
import { useHandleLoginOrSignUpProps } from '../hooks/handleLoginOrSignUpProps'
import { useTrackAuthInfo } from '../hooks/trackAuthInfo'

import type { LoginSchemaInput } from '@loc/server/interface/track/trackEventParams.common'
import type { ITrackCoreProps } from '.'
import type { TrackCustomEventProps } from '..'
import type { ICoreItem } from './type'

import { removeTrackAuth } from '@/contexts/AuthContext/hooks/trackSignInOrSignUp'

export const useTrackLogin = ({
  eventTracking,
}: ITrackCoreProps): ICoreItem<LoginSchemaInput> => {
  const { setTrackAuthInfo, trackAuthInfoLatest } = useTrackAuthInfo()
  const { handleLoginOrSignUpProps } = useHandleLoginOrSignUpProps()

  const trackEvent = async (
    props: LoginSchemaInput & TrackCustomEventProps,
  ) => {
    const { name, meta, commonParamsLatest, method, status, type } = props

    const { commonParams, gaCommonParams } = commonParamsLatest

    // 5 秒防重复
    const commTimestamp = commonParams.commTimestamp
    const trackAuthTimestamp = Number(
      trackAuthInfoLatest.current?.[LoginTrackName],
    )
    if (trackAuthTimestamp && commTimestamp - trackAuthTimestamp < 5000) {
      console.debug('login track skipped (5s dedup)', {
        name,
        lastTimestamp: new Date(trackAuthTimestamp).toLocaleString(),
        currentTimestamp: new Date(commTimestamp).toLocaleString(),
      })
      return
    }

    // 解析 origin_url
    const origin_url = get(meta, 'origin_url', '')
    const originInfo = handleLoginOrSignUpProps(origin_url)
    const totalMeta = { ...meta, ...originInfo }

    const params = [
      {
        name,
        method,
        type,
        status,
        meta: totalMeta,
        ...commonParams,
      },
    ]

    sa.track(name, {
      method,
      item_name: type,
      ...totalMeta,
      ...gaCommonParams,
    })

    handleIdentify({
      userId: gaCommonParams.user_id,
      emailSha256: gaCommonParams.email_sha256,
    })

    try {
      await eventTracking(params)
      setTrackAuthInfo({
        [SignUpTrackName]: trackAuthInfoLatest.current?.[SignUpTrackName] || '',
        [LoginTrackName]: `${commTimestamp}`,
      })
    } catch (error) {
    } finally {
      removeTrackAuth()
    }
  }

  return {
    trackEvent,
  }
}
